var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Search_icon",
    "data-name": "Search icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.617,
    height: 26.452,
    viewBox: "0 0 25.617 26.452",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7757",
    "data-name": "Path 7757",
    d: "M180.424,555.46A10.419,10.419,0,0,1,179,556.651l7.418,7.418a1.42,1.42,0,0,0,2.008,0l.608-.608a1.42,1.42,0,0,0,0-2.008l-7.418-7.418A10.422,10.422,0,0,1,180.424,555.46Z",
    transform: "translate(-163.832 -538.033)",
    fill: "#3c3c3b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7758",
    "data-name": "Path 7758",
    d: "M233.956,485.381a9.3,9.3,0,1,1,0-13.156A9.3,9.3,0,0,1,233.956,485.381Zm-1.605-11.551a7.033,7.033,0,1,0,0,9.946A7.033,7.033,0,0,0,232.351,473.83Z",
    transform: "translate(-218.075 -469.5)",
    fill: "#3c3c3b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchicon);
export default __webpack_public_path__ + "static/media/Search icon.15e816d716d93ba3d7c5219abea620a5.svg";
export { ForwardRef as ReactComponent };